/* import __COLOCATED_TEMPLATE__ from './verification-step.hbs'; */
import { action } from '@ember/object';
import { dateFormat } from 'client-portal/utils/date-time';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import styles from './verification-step.module.scss';

export default class PaymentLinkVerificationStep extends Component {
  @service store;
  @service router;
  @service intl;

  styles = styles;
  @tracked dateOfBirth = null;
  @tracked isPersisting = false;
  @tracked errorMessage = null;

  get isConfirmDisabled() {
    return !this.dateOfBirth || this.isPersisting;
  }

  @action
  async confirmVerification() {
    if (this.isConfirmDisabled) {
      return;
    }

    this.isPersisting = true;
    try {
      let adapter = this.store.adapterFor('payment-link');
      await adapter.verifyDateOfBirth(
        this.args.paymentLink.uuid,
        this.dateOfBirth.format(dateFormat)
      );
      this.router.refresh();
    } catch (error) {
      this.errorMessage = this._getErrorMessage(error);
    } finally {
      this.isPersisting = false;
    }
  }

  _getErrorMessage(error) {
    let errorCode = error?.errors?.[0]?.code;

    switch (errorCode) {
      case 'dob_mismatch':
        return this.intl.t('paymentLink.verificationStep.errors.dobMismatch');
      case 'expired_link':
      case 'invalid_session':
        return this.intl.t('paymentLink.verificationStep.errors.linkExpired');
      default:
        return this.intl.t('paymentLink.verificationStep.errors.unexpectedError');
    }
  }
}
